<template>
  <menu id="jump-navigation" class="absolute bottom-0 z-[51] w-full text-White ">
    <div class="group flex w-full  justify-around px-4" :data-index="index" aria-label="hidden">
      <NuxtLink :tabindex="index == 0 ? -1 : 0" :to="localePath({ name: 'Medications' })"
        class="grow p-[5.5vw] transition-opacity delay-100 group-data-[index=0]:opacity-0 group-data-[index=0]:delay-0 hover:text-Blue-Primary focus-visible:text-focus focus-visible:outline-none">
        <IconPill />
      </NuxtLink>
      <NuxtLink :tabindex="index == 1 ? -1 : 0" :to="localePath({ name: 'ActiveIngredients' })"
        class="grow p-[5.5vw] transition-opacity delay-100 group-data-[index=1]:opacity-0 group-data-[index=1]:delay-0 hover:text-Blue-Primary focus-visible:text-focus focus-visible:outline-none">
        <IconDrip />
      </NuxtLink>
      <NuxtLink :tabindex="index == 2 ? -1 : 0" :to="localePath({ name: 'index' })"
        class="grow p-[5.5vw] transition-opacity delay-100 group-data-[index=2]:opacity-0 group-data-[index=2]:delay-0 hover:text-Blue-Primary focus-visible:text-focus focus-visible:outline-none">
        <IconHomeLogoSiluette />
      </NuxtLink>
      <NuxtLink :tabindex="index == 3 ? -1 : 0" :to="localePath({ name: 'GeneralInformation' })"
        class="grow p-[5.5vw] transition-opacity delay-100 group-data-[index=3]:opacity-0 group-data-[index=3]:delay-0 hover:text-Blue-Primary focus-visible:text-focus focus-visible:outline-none">
        <IconInfo />
      </NuxtLink>
      <NuxtLink :tabindex="index == 4 ? -1 : 0" :to="localePath({ name: 'Settings' })"
        class="grow p-[5.5vw] transition-opacity delay-100 group-data-[index=4]:opacity-0 group-data-[index=4]:delay-0 hover:text-Blue-Primary focus-visible:text-focus focus-visible:outline-none">
        <IconGearwheel />
      </NuxtLink>
    </div>
  </menu>
  <div class="absolute bottom-0 z-50 w-full">
    <UiMobileBar :data-index="index" :index="index" />
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const router = useRouter()
const open = ref(false)
const localePath = useLocalePath()

const index = computed(() => {
  let oldi = index.value

  if (
    router.currentRoute.value.name?.startsWith('Medications') ||
    router.currentRoute.value.name?.startsWith('Medicine')
  ) {
    return 0
  } else if (router.currentRoute.value.name?.startsWith('ActiveIngredient')) {
    return 1
  } else if (router.currentRoute.value.name?.startsWith('index')) {
    return 2
  } else if (router.currentRoute.value.name?.startsWith('GeneralInformation')) {
    return 3
  } else if (router.currentRoute.value.name?.startsWith('Settings')) {
    return 4
  } else if (oldi) {
    return oldi
  }
  return 2
})
</script>
